if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slider = this.querySelector('slider-component');
        if (this.slider) {
          this.slider.addEventListener('slideChanged', this.onSlideChanged.bind(this));
          // ModalDialog closes on any mouse click that isn't on
          // deferred-media/product-model — the carousel arrows are neither,
          // so stop the click here or every arrow click would close the modal.
          this.slider.querySelectorAll('.slider-button').forEach((button) => {
            button.addEventListener('pointerup', (event) => event.stopPropagation());
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.activateSlide(this.openedBy.getAttribute('data-media-id'), { instant: true });
      }

      onSlideChanged(event) {
        const currentSlide = event.detail.currentElement;
        if (!currentSlide) return;
        this.activateSlide(currentSlide.dataset.mediaId, { scroll: false });
      }

      activateSlide(mediaId, { instant = false, scroll = true } = {}) {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeSlide) return;
        activeSlide.classList.add('active');

        if (scroll) {
          activeSlide.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: instant ? 'instant' : 'smooth',
          });
        }

        const activeMedia = activeSlide.querySelector('deferred-media, product-model');
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
